<template>
    <modal
        data-activity="email-compose"
        :classes="(aiOpen ? 'new-email ai-open' : 'new-email')"
        v-bind:visible="isModalVisible"
        v-on:closeModal="closeModal"
    >
        <template slot="header">
            <div class="name" v-if="!action">NEUE EMAIL</div>
            <div class="name" v-else-if="action === 'reply'">Antworten</div>
            <div class="name" v-else-if="action === 'replyAll'">Allen Antworten</div>
            <div class="name" v-else-if="action === 'forward'">Weiterleiten</div>

            <div v-if="!isListMode">
                <toggle-switch v-model="emailType">
                    <option value="client">Email an Kunde</option>
                    <option value="provider">Email an Leistungsträger</option>
                    <option value="providerBulk">Massenemails an Leistungsträger</option>
                </toggle-switch>
            </div>
        </template>


        <template slot="content">
            <!-- Listen-Modus (Einkauf): Reisen ergeben sich aus den ausgewählten Leistungen -->
            <orders-select
                v-if="!isListMode"
                :params="{_groups: ['client_read']}"
            ></orders-select>


            <email-form
                v-if="emailType !== 'providerBulk'"
                v-bind:preselected-order     = "preselectedOrder"
                v-bind:preselected-request   = "preselectedRequest"
                v-bind:preselected-contact   = "isReply ? null : preselectedContact"
                v-bind:select-template    = "selectTemplate"
                v-bind:attach-document    = "attachDocument"
                v-bind:skip-init          = "isMounted"
                v-on:closeModal = "refresh => $emit('closeModal', refresh)"
                ref="form"
            ></email-form>

            <bulk-email-form
                v-else
                v-bind:preselected-order  = "preselectedOrder"
                v-bind:bulk-request-ids   = "bulkRequestIds"
                v-bind:attach-document    = "attachDocument"
                v-bind:skip-init          = "isMounted"
                v-on:closeModal = "refresh => $emit('closeModal', refresh)"
                ref="bulkForm"
            ></bulk-email-form>
        </template>
    </modal>
</template>



<script>
import Modal    from '@components/Modal';
import store        from '@components/emails/store';
import EmailForm    from './EmailForm';
import BulkEmailForm from './BulkEmailForm';
import OrdersSelect from './OrdersSelect';
import ToggleSwitch from "@components/form/ToggleSwitch";
import {settings} from "@clientSpecific/utilities/settings";
export default {
    store: store,
    props: {
        isModalVisible:     { type: Boolean, required: true }, //controls if modal is visible
        preselectedOrder:   { default: null }, //preselects Orders
        preselectedRequest: { default: null }, //preSelects requests
        preselectedContact: { default: null }, //preSelects Contact
        selectTemplate:     { default: null}, //preSelects a template
        attachDocument:     { type: Object, default: null}, //attaches a document
        bulkRequestIds:     { type: Array, default: null } //öffnet direkt als Massenemail für genau diese Zusatzleistungs-Anfragen (reiseübergreifend, eine Email pro LT und Reise)
    },
    data: function() {
        return {
            settings: settings,
            isMounted: false
        }
    },

    created: function() {
        //Massenemail-Modus wird pro Modal-Öffnung bewusst gewählt (sonst Konflikt mit preselectedRequest/Concept-Flows);
        //Kontaktwahlen aus früheren Massenemails nicht in neue Aufträge übernehmen
        this.$store.state.bulkMode = this.isListMode;
        this.$store.state.bulkListMode = this.isListMode;
        this.$store.state.bulkContacts = {};
    },

    mounted: function() {
        this.isMounted = true;
    },
    computed: {
        aiOpen () {
            return this.$layout.rightSideBar;
        },

        isListMode () {
            return !!this.bulkRequestIds;
        },

        emailType: {
            get: function() {
                return this.$store.state.bulkMode ? 'providerBulk' : this.$store.state.emailType;
            },
            set: function(value) {
                let bulkModeChanged = this.$store.state.bulkMode !== (value === 'providerBulk');
                this.$store.state.bulkMode = value === 'providerBulk';
                //bulkMode läuft intern als 'provider' (Template-Kategorie, Du/Sie-Settings, Template-Cache)
                this.$store.state.emailType = value === 'client' ? 'client' : 'provider';

                if(bulkModeChanged) {
                    this.$store.state.requestsSelected = [];
                }
                if(bulkModeChanged && value === 'providerBulk') {
                    //im Einzel-Modus kann newEmail.textHtml bereits GERENDERT (oder manuell
                    //bearbeitet) sein — der Bulk-Modus braucht das rohe Twig-Template, also
                    //den Reload durch resetTemplates/fillEmailBody nicht per Confirm blockieren
                    this.$store.state.emailManuallyChanged = false;
                }

                if(value !== 'client') {
                    if(this.settings.emails.isFormal['provider']) {
                        this.$store.state.isFormal = settings.emails.selectedIsFormal.provider;
                    }
                    this.$store.dispatch('getRequests');
                } else {
                    this.$store.state.isFormal = settings.emails.selectedIsFormal.client;
                }
                this.$store.dispatch('resetToContacts', {contactToSelect: null, selectContact: true});
                this.$store.dispatch('resetTemplates');
            }
        },

        action: function () { return this.$store.state.action; },

        isReply: function () {
            return this.$store.state.action === 'reply' ||
                this.$store.state.action === 'replyAll' ||
                this.$store.state.action === 'forward';
        }
    },

    methods: {
        closeModal () {
            this.$store.state.isOpen = false;
            this.$emit('closeModal');
        }
    },

    components: {
        ToggleSwitch,
        EmailForm,
        BulkEmailForm,
        Modal,
        OrdersSelect
    }
}
</script>
